import { VehiclePricing } from '../../Entities/Vehicle/VehiclePricing.entity';

export const canShowDiscount = (pricing: VehiclePricing) =>
  Boolean(pricing.discount && pricing.originalPrice);
